// extracted by mini-css-extract-plugin
export default {"holder":"SectionHeader_holder__jKGqW","header":"SectionHeader_header__HLo8g","line":"SectionHeader_line__BNhSV"};